module.exports = __webpack_public_path__ + "static/media/iconfinder_basket_1814090.d162faea.png";